/* Build information */
export const version: string = process.env.VERSION || 'v000';

export const allowedHost: string = process.env.ALLOWED_HOST || '';

/* Endpoints and credentials */
export const gqlApi: string = process.env.GQL_API || '';

/* Sentry */
const sentryDsn = process.env.SENTRY_DSN || '';

export const [, sentryKey = ''] = sentryDsn.match(/:\/\/(.*?)@/) || [];
export const [, sentryProject = ''] = sentryDsn.match(/\/([^\/]+)\/?$/) || [];
export const sentryClient = 'ikea.sentry.register';

export const sentryRegex: RegExp = /\/[a-z0-9]{2}\/[a-z0-9]{2}\/gift-registry\/agent\//;

export const getMarket = (): Record<string, string> => {
  const [country, language] = window.location.pathname.match(/\w{2}/g) ?? [];
  return {
    country: country ?? '',
    language: language ?? '',
  };
};
